export default __webpack_public_path__ + "static/media/video.a2703484.mp4";